import { ChatHandlePane } from "./ChatHandlePane";
import styles from "./ChatAssistantNode.module.scss";
import { useSize } from "ahooks";
import { useRef } from "react";
import { ChatInterfaceUtil } from "./ChatInterfaceUtil";
import React from "react";
import { StreamText } from "../../components/StreamText";
import cls from "classnames";
export function ChatAssistantNode(props) {
  var containerRef = useRef(null);
  var containerSize = useSize(containerRef);
  var heightRef = useRef(0);
  var streamTextFunctionRef = useRef(null);
  function _onStreamingContentChanged(value) {
    var _props$onStreamingCon, _containerSize$height;
    (_props$onStreamingCon = props.onStreamingContentChanged) === null || _props$onStreamingCon === void 0 || _props$onStreamingCon.call(props);
    heightRef.current = (_containerSize$height = containerSize === null || containerSize === void 0 ? void 0 : containerSize.height) !== null && _containerSize$height !== void 0 ? _containerSize$height : 0;
  }
  var copy = function copy() {
    ChatInterfaceUtil.copy(props.message);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftCornersBox
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(styles.chatPubBubbleCorner, props.showMask ? styles.lftMsgMask : "")
  }), /*#__PURE__*/React.createElement("div", {
    className: cls(styles.lftTopCorners, props.showMask ? "" : styles.showRadiusBottomLft)
  })), /*#__PURE__*/React.createElement("div", {
    onClick: copy,
    className: styles.messageContainer
  }, props.isError ? /*#__PURE__*/React.createElement("span", {
    className: styles.error
  }, "An error occurred. ") : null, /*#__PURE__*/React.createElement(StreamText, {
    ref: streamTextFunctionRef,
    className: styles.message,
    disabled: props.disabledStream,
    isStreamStopped: props.isStreamStopped,
    content: props.message
    // onStreamingStateChanged={ setStreaming }
    ,
    onStreamingContentChanged: function onStreamingContentChanged(value) {
      return _onStreamingContentChanged(value);
    },
    onStreamingContentStopped: function onStreamingContentStopped(value) {
      if (value) {
        var _props$onStreamingCon2;
        (_props$onStreamingCon2 = props.onStreamingContentStopped) === null || _props$onStreamingCon2 === void 0 || _props$onStreamingCon2.call(props, {
          type: "Assistant",
          value: value
        });
      } else {
        var _props$onStreamingCon3;
        (_props$onStreamingCon3 = props.onStreamingContentStopped) === null || _props$onStreamingCon3 === void 0 || _props$onStreamingCon3.call(props);
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rightCorners
  })), props.isLast && /*#__PURE__*/React.createElement(ChatHandlePane, {
    isStreaming: !props.isStreamStopped,
    onRegenerateClicked: function onRegenerateClicked() {
      return props.onRegenerateClicked();
    },
    onStopGenerateClicked: function onStopGenerateClicked() {
      var _streamTextFunctionRe;
      (_streamTextFunctionRe = streamTextFunctionRef.current) === null || _streamTextFunctionRe === void 0 || _streamTextFunctionRe.stop(true);
    }
  }));
}